
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import mixin from "./mixin";
import * as modals from "@/lib/modals";
import draggable from "vuedraggable";
import { getModule } from "vuex-module-decorators";
import OrderModule from "@/store/modules/order";
import RightClickMenu from "@/components/widgets/RightClickMenu.vue";
import notifications from "@/lib/notifications";
import Select from "@/components/form/Select.vue";

@Component({
    name: modals.imageUploadModal,
    components: {
        RightClickMenu,
        draggable,
        Select
    }
})

export default class ImageUploadModal extends Mixins(mixin) {
    uploadRegionDefaultText: string = "Drag one or more files to attach to this order. Or click here to select files.";
    uploadRegionText: string = "Drag one or more files to attach to this order. Or click here to select files.";

    files: any[] = [];
    orderModule = getModule(OrderModule);
    isSaving: boolean = false;
    selectedDocumentType: string = null;
    documentTypeOptions: any[] = [
        { label: "Attempt", value: "AT" },
        { label: "Attended Delivery", value: "ORD" },
        { label: "Bill of Lading", value: "BOL" },
        { label: "Damaged Item - Loading", value: "DML" },
        { label: "Damaged Item - Receiving", value: "DMR" },
        { label: "Manual Scan", value: "UNS" },
        { label: "Proof of Delivery", value: "POD" },
        { label: "Refused Freight", value: "RF" },
        { label: "Short on Inbound", value: "SOI" },
        { label: "Unattended", value: "UN" }
    ];

    load() {
        window.addEventListener("error", this.handleError);
        this.files.splice(0, this.files.length);
        this.isSaving = false;
        this.selectedDocumentType = null;
    }

    unload() {
        this.files.splice(0, this.files.length);
        window.removeEventListener('error', this.handleError)
    }

    dragOverHandler(event: any) {
        event.preventDefault();

        if (event.dataTransfer.items.length > 0 && event.dataTransfer.items[0].kind == 'file') {
            event.dataTransfer.dropEffect = 'copy';
            this.uploadRegionText = `Drop ${event.dataTransfer.items.length} file(s) to attach to this order.`;
        } else {
            event.dataTransfer.dropEffect = 'none';
        }
    }

    dragLeaveHandler(event: any) {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'none';
        this.uploadRegionText = this.uploadRegionDefaultText;
    }

    dropHandler(event: any) {
        event.preventDefault();
        this.uploadRegionText = this.uploadRegionDefaultText;

        if (event.dataTransfer.items) {

            [...event.dataTransfer.items].forEach((item, i) => {
                if (item.kind === 'file') {
                    const file = item.getAsFile();
                    this.files.push(file);
                }
            });
        }
    }

    clickHandler(event: any) {
        let fileElem = this.$refs['fileInput'] as HTMLInputElement;
        fileElem.click();
    }

    removeFile(index: number) {
        this.files.splice(index, 1);
    }

    cancel() {
        this.hideModal();
    }

    async saveDocumentsAsync() {
        this.isSaving = true;
        const request = {
            orderHeaderNumber: this.orderModule.currentOrder.headerNumber,
            imageType: this.selectedDocumentType,
            files: this.files
        };

        try {
            const response = await this.orderModule.addOrderImages(request);

            if (response.successful) {
                notifications.success("Upload Complete", "Files have been uploaded successfully.");
                this.orderModule.loadOrderImages(this.orderModule.currentOrder);
                this.orderModule.loadOrderThumbnails(this.orderModule.currentOrder);
                this.hideModal();
            } else {
                notifications.error("Unable to upload", `Error uploading files. ${response.message}`);
            }
        } catch (error) {
            notifications.error("Unable to upload", `Error uploading files. Please try again. ${error}`);
            this.hideModal();
        }
        this.isSaving = false;
    }

    getSaveText(): string {
        if (this.files.length == 1) return "Save 1 File";
        if (this.files.length > 1) return `Save ${this.files.length} Files`;
        return "Save";
    }

    handleError(error: any) {
        notifications.error("Unable to upload", "Error uploading files. Please try again.");
        this.hideModal();
    }

    inputChange(event: any) {
        if (event.target.files) {
            [...event.target.files].forEach((file, i) => {
                this.files.push(file);
            });
        }
    }
}

